import axios from 'axios';
interface AuthResponse {
  data: {
    jwt: string;
  };
}
class AuthService {
  private static instance: AuthService;
  private jwt: string | null = null;
  private loginTime: string | null = null;

  private constructor() {
    // Initialize from sessionStorage
    this.jwt = sessionStorage.getItem('jwt');
    this.loginTime = sessionStorage.getItem('loginTime');
  }

  public static getInstance(): AuthService {
    if (!AuthService.instance) {
      AuthService.instance = new AuthService();
    }
    return AuthService.instance;
  }

  public async getAuthorization(): Promise<string> {
    // Check if JWT is empty
    console.log('getAuthorization'+this.jwt);
    if (!this.jwt) {
      return this.refreshToken();
    }
    // Check if JWT is expired (assuming 1 hour expiration)
    const loginTimestamp = this.loginTime ? new Date(this.loginTime).getTime() : 0;
    const currentTime = new Date().getTime();
    const hoursDifference = (currentTime - loginTimestamp) / (1000 * 60 * 60);
    if (hoursDifference > 23) {
      return this.refreshToken();
    }
    console.log('getAuthorization'+this.jwt);
    return this.jwt;
  }
  private async refreshToken(): Promise<string> {
    try {
  
      //http://localhost:8180/auth/login
      //https://healthcare.ledgerb.io/auth/login
      console.log('refreshToken');
      const response = await axios.post<AuthResponse>('/auth/login', {
        username:"admin",
        password: "R5t6y7u8()"
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          // 'Access-Control-Allow-Origin': '*',
          // 'Access-Control-Allow-Methods': 'POST',
          // 'Access-Control-Allow-Headers': 'Content-Type, Authorization',
          // Access-Control-Allow-Credentials:true
        },
        //withCredentials: true,
      });
      this.jwt = response.data.data.jwt;
      this.loginTime = new Date().toISOString();
      
      sessionStorage.setItem('jwt', this.jwt);
      sessionStorage.setItem('loginTime', this.loginTime);
      console.log('refreshToken jwt'+this.jwt);
      return this.jwt;
    } catch (error) {
      console.error('Error refreshing token:', error);
      throw error;
    }
  }
}
export default AuthService;